import React,{ useState,useEffect} from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import Input from "./../management/input";
import { useForm, Controller } from "react-hook-form";
import Select from "./../management/select";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const schema = yup.object({
  fname: yup.string().required("ระบุชื่อ"),
  lname: yup.string().required("ระบุสกุล"),
  account: yup.string().required("ระบุ account"),
  password: yup.string().required("ระบุ password"),
  code: yup.string().required("ระบุรหัสลูกค้า"),
  type: yup.string().required("ระบุประเภท"),
  codeid: yup.string().required("ระบุระหัสบัตรประชาชน"),
  producttype: yup.string().required("ระบุประเภทสินค้า"),
  telephone: yup.string().required("ระบุเบอร์โทร"),
  number: yup.string().required("ระบุชื่อ"),
  moo: yup.string().required("ระบุหมู่"),
  aumper: yup.string().required("เลือกอำเภอ"),
  provine: yup.string().required("เลือกจังหวัด"),
  tumbol: yup.string().required("เลือกตำบล"),
  zipcode: yup.string().required("ระบุรหัสไปรษณีย์"),
  bankname: yup.string().required("ระบุชื่อธนาคาร"),
  accountname: yup.string().required("ระบุชื่อบัญชี"),
  accountnumber: yup.string().required("กรอกหมายเลขบัญชี"),
});

const Modaleditproduct = ({ id,isOpen, onCancel, onConfirm, list }) => {

  const [demolist, setdemolist] = useState([{_id:0,name:"all",_id:1,name:"AA"}])
  const [onSave, setonSave] = useState(false);
  const [disabledata, setdisabledata] = useState({
    code:false,
    cardid:false,
  })

  useEffect(() => {
    
   const loadData =  () => {
     if (id===1){
      setdisabledata({code:true,cardid:true})
     }     
   }
   loadData();
  },[id])
  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
    control,
  } = useForm({ resolver: yupResolver(schema) });
  const onSubmit = (data) => {
    
  };

  const handleCancle = (e) => {
    onCancel(false);
  };

  return (
    <div>
      <Modal
        className="modal-dialog modal-xl"
        isOpen={isOpen}
        toggle={onCancel}
      >
        <ModalHeader>
          <p className=" text-primary me-2  fs-2 fw-bold">
          <i className="bi bi-book-half me-2"/>
            {list[0].header}
          </p>
        </ModalHeader>
        <ModalBody>
          <>
            <div className="modal-body p-0">
              <div className="shadow ">
                <div className="card-mb-4 d-flex align-items-center justify-content-center h-100 bg-primary text-light">
                  <span aria-hidden="true" className="fa fa-user me-2"></span>
                  ข้อมูลลูกค้า
                </div>
                <div className="card-body p-2">
                  <div className="row">
                    <div className="col-sm-6 col-xs-12">
                      <Input
                        icon="bi bi-book-fill text-primary me-2"
                        label="เลขที่บัตร พขร"
                        name="code"
                        register={register}
                        required
                        errors={errors.code}
                        disabled ={disabledata.code}
                      />
                    </div>
                    <div className="col-sm-6 col-xs-12">
                      <Input
                        icon="bi bi-map-fill text-primary me-2"
                        label="เลขที่ใบชั่ง"
                        name="cardid"
                        register={register}
                        required
                        errors={errors.cardid}
                     
                        disabled ={disabledata.cardid}
                      />
                    </div>
                    <div className="col-sm-12 col-xs-12 col-lg-6">
                      <div className="row">
                        <div className="col-lg-6">
                          <Input
                            icon="bi bi-person-check-fill text-primary me-2"
                            label="ชื่อ"
                            name="fname"
                            register={register}
                            required
                            errors={errors.fname}
                            disabled
                          />
                        </div>
                        <div className="col-lg-6">
                          <Input
                            icon="bi bi-person-lines-fill text-primary me-2"
                            label="สกุล"
                            name="cardid"
                            register={register}
                            required
                            errors={errors.cardid}
                            disabled
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <div className="row">
                        <div className="col-lg-3">
                          <Input
                            icon="bi bi-truck text-primary me-2"
                            label="ทะเบียนหัว"
                            name="cardid"
                            register={register}
                            required
                            errors={errors.cardid}
                            disabled
                          />
                        </div>

                        <div className="col-lg-3 mt-2">
                          <Input
                            name="cardid"
                            register={register}
                            required
                            errors={errors.cardid}
                            disabled
                          />
                        </div>
                        <div className="col-lg-6">
                          <Select
                            icon="bi bi-pin-map-fill text-primary me-2"
                            label="จังหวัด"
                            name="cardid"
                            list={demolist}
                            register={register}
                            required
                            errors={errors.cardid}
                            disabled
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-sm-12 col-xs-12 col-lg-6">
                      <Select
                        icon="bi bi-layers-fill text-primary me-2"
                        label="ประเภทรถ"
                        name="cardid"
                        list={demolist}
                        register={register}
                        required
                        errors={errors.cardid}
                        disabled
                      />
                    </div>
                    <div className="col-lg-6">
                      <div className="row">
                        <div className="col-lg-3">
                          <Input
                            icon="bi bi-truck-flatbed text-primary me-2"
                            label="ทะเบียนหาง"
                            name="cardid"
                            register={register}
                            required
                            errors={errors.cardid}
                            disabled
                          />
                        </div>

                        <div className="col-lg-3 mt-2">
                          <Input
                            name="cardid"
                            register={register}
                            required
                            errors={errors.cardid}
                            disabled
                          />
                        </div>
                        <div className="col-lg-6">
                          <Select
                            icon="bi bi-pin-map-fill text-primary me-2"
                            label="จังหวัด"
                            name="cardid"
                            list={demolist}
                            register={register}
                            required
                            errors={errors.cardid}
                            disabled
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="row">
                        <div className="col-lg-6">
                          <Input
                            icon="bi bi-book-half text-primary me-2"
                            label="DO"
                            name="cardid"
                            register={register}
                            required
                            errors={errors.cardid}
                            disabled
                          />
                        </div>
                        <div className="col-lg-6">
                          <Input
                            icon="bi bi-telephone-forward-fill text-primary me-2"
                            label="เบอร์รถ"
                            name="cardid"
                            register={register}
                            required
                            errors={errors.cardid}
                            disabled
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="row">
                        <div className="col-lg-6">
                          <Input
                            icon="bi bi-bank text-primary me-2"
                            label="บริษัทขนส่ง"
                            name="cardid"
                            register={register}
                            required
                            errors={errors.cardid}
                            disabled
                          />
                        </div>
                        <div className="col-lg-6">
                          <Input
                            icon="bi bi-book-half text-primary me-2"
                            label="WOID"
                            name="cardid"
                            register={register}
                            required
                            errors={errors.cardid}
                            disabled
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row  mt-2">
                <div className="col-lg-12">
                  <div className="card shadow border-0">
                    <div className="card-mb-4 d-flex align-items-center justify-content-center h-100 bg-warning">
                      <span
                        aria-hidden="true"
                        className="fa fa-address-card me-2"
                      >
                        {" "}
                      </span>{" "}
                      ข้อมูลสินค้า
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-lg-6">
                          <Select
                            icon="bi bi-layers-fill text-primary me-2"
                            label="ประเภทสินค้า"
                            name="cardid"
                            list={demolist}
                            register={register}
                            required
                            errors={errors.cardid}
                          />
                        </div>
                        <div className="col-lg-6">
                          <div className="row">
                            <div className="col-lg-6">
                              <Select
                                icon="bi bi-layers-fill text-primary me-2"
                                label="ชื่อสินค้า"
                                name="cardid"
                                list={demolist}
                                register={register}
                                required
                                errors={errors.cardid}
                              />
                            </div>
                            <div className="col-lg-6">
                              <Input
                                icon="bi bi-file-earmark-fill text-primary me-2"
                                label="วัตถุประสงค์"
                                name="cardid"
                                register={register}
                                required
                                errors={errors.cardid}
                                disabled
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <Select
                            icon="bi bi-house-fill text-primary me-2"
                            label="สถานที่จัดเก็บ"
                            name="cardid"
                            list={demolist}
                            register={register}
                            required
                            errors={errors.cardid}
                            disabled
                          />
                          <div className="col-sm-6 col-xs-12"></div>
                        </div>
                        <div className="col-sm-6 col-xs-12">
                          <Input
                            icon="bi bi-triangle-half text-primary me-2"
                            label="ต้นทางสินค้า"
                            name="cardid"
                            register={register}
                            required
                            errors={errors.cardid}
                            disabled
                          />
                        </div>
                        <div className="col-sm-6 col-xs-12">
                          <Input
                            icon="bi bi-tags-fill text-primary me-2"
                            label="หมายเหตุ"
                            name="cardid"
                            register={register}
                            required
                            errors={errors.cardid}
                            disabled
                          />
                        </div>
                        <div className="col-lg-6 col-xs-12">
                          <Select
                            icon="bi bi-bank2 text-primary me-2"
                            label="บริษัทรับสินค้า"
                            name="cardid"
                            list={demolist}
                            register={register}
                            required
                            errors={errors.cardid}
                            disabled
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        </ModalBody>
        <ModalFooter>
          <div className="col-auto">
            <div className="row">
              <div className="card border-0 col-auto">
                <Button color="primary" disabled ={onSave} onClick={handleSubmit(onSubmit)}>
                  Confirm
                </Button>{" "}
              </div>
              <div className="card border-0  col-auto">
                <Button color="secondary" onClick={handleCancle}>
                  Cancel
                </Button>
              </div>
            </div>
          </div>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default Modaleditproduct;
